import { createFileRoute } from "@tanstack/react-router";
import Kiosk from "@/pages/Kiosk";

export const Route = createFileRoute("/product/kiosk")({
  component: Kiosk,
});
